import React from 'react';
import { DataList } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';

import { columnConfigs } from './listConfig';
import useService from './useService';

const DEFAULTS = {
	pageDetails: {
		pageSize: 1,
		pageNo: 1
	}
};

const ReferralList: React.FC<{}> = () => {
	const { getReferralsData } = useService();

	return (
		<DataList
			defaults={DEFAULTS}
			fetchData={getReferralsData}
			columnConfigs={columnConfigs}
			hideActions
			entity={LIST_ENTITY_NAMES.REFERRALS}
		/>
	);
};

export default ReferralList;
